export default __webpack_public_path__ + "locales/de/Common.json?hash=e32736b1a1b13701acd14d7d84c26566";